import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Globe } from 'lucide-react';

const languages = [
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'en', label: 'English', flag: '🇬🇧' }
];

export const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  
  const normalizedLng = (i18n.resolvedLanguage || i18n.language || 'it').split('-')[0];
  const currentLanguage = languages.find(lang => lang.code === normalizedLng) || languages[0];

  const handleLanguageChange = (langCode: string) => {
    // Persist language choice even when localStorage is blocked (some mobile / privacy modes)
    try {
      localStorage.setItem('i18nextLng', langCode);
    } catch {
      // ignore
    }
    try {
      document.cookie = `df_lang=${encodeURIComponent(langCode)}; path=/; max-age=31536000; samesite=lax`;
    } catch {
      // ignore
    }

    i18n.changeLanguage(langCode);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="sm" 
          className="flex items-center gap-1.5 px-2"
        >
          <Globe className="h-4 w-4" />
          <span className="text-lg">{currentLanguage.flag}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[120px]">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            className={`flex items-center gap-2 cursor-pointer ${
              i18n.language === lang.code ? 'bg-accent' : ''
            }`}
          >
            <span className="text-lg">{lang.flag}</span>
            <span>{lang.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
